import { memo } from 'react';
import clsx from 'clsx';

const ActionToolbar = memo(({ searchQuery, onSearchChange, actionButton, placeholder = 'Search...', className = '', disabled = false, theme = 'light' }) => {
    return (
        <div className={clsx('flex items-center justify-between', 'bg-white dark:bg-gray-800', 'p-4 rounded-lg', 'my-4', 'border-2 border-gray-200 dark:border-gray-600 shadow-md')}>
            <div className="flex items-center space-x-2">
                <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => onSearchChange(e.target.value)}
                    onFocus={(e) => console.log('Input focused')}
                    placeholder={placeholder}
                    className={clsx('rounded-lg p-2', 'border-2 border-gray-200 dark:border-gray-600', 'bg-gray-100 text-black', 'dark:bg-gray-700/50 dark:text-white')}
                />
            </div>
            {/* Action Button */}
            {actionButton && <div className="flex-shrink-0">{actionButton}</div>}
        </div>
    );
});

ActionToolbar.displayName = 'ActionToolbar';

export default ActionToolbar;
